<p-dialog
  header="Modifier les opérations de maintenance"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '90vw', 'max-width': '900px' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  (onHide)="onCancel()"
>
  <div class="edit-operations-maintenance-modal">
    <div class="modal-content">
      <form [formGroup]="form">
        <div formArrayName="operationsMaintenance" class="operations-list">
          <div
            *ngFor="
              let operationGroup of formArray.controls;
              let i = index
            "
            [formGroupName]="i"
            class="operation-row"
            [ngClass]="{ deleted: !isVisibleRow(i) }"
            [style.display]="isVisibleRow(i) ? 'flex' : 'none'"
          >
            <div class="operation-description">
              <label for="description_{{ i }}">Description</label>
              <input
                type="text"
                pInputText
                formControlName="description"
                placeholder="Description de l'opération de maintenance"
                id="description_{{ i }}"
                [class.ng-invalid]="
                  operationGroup.get('description')?.invalid &&
                  operationGroup.get('description')?.touched
                "
              />
              <small
                *ngIf="
                  operationGroup.get('description')?.invalid &&
                  operationGroup.get('description')?.touched
                "
                class="error-message"
              >
                La description est requise
              </small>
            </div>

            <div class="operation-periodicity">
              <label for="periodicity_{{ i }}">Périodicité</label>
              <p-select
                appendTo="body"
                formControlName="periodicity"
                [options]="periodicityOptions"
                placeholder="Sélectionner une périodicité"
                id="periodicity_{{ i }}"
                [class.ng-invalid]="
                  operationGroup.get('periodicity')?.invalid &&
                  operationGroup.get('periodicity')?.touched
                "
                styleClass="w-full"
              ></p-select>
              <small
                *ngIf="
                  operationGroup.get('periodicity')?.invalid &&
                  operationGroup.get('periodicity')?.touched
                "
                class="error-message"
              >
                La périodicité est requise
              </small>
            </div>

            <div class="operation-actions">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-trash"
                class="p-button-danger p-button-sm p-button-outlined"
                (click)="deleteAt(i)"
                [disabled]="formArray.length <= 1"
              ></button>
            </div>
          </div>

          <div class="add-operation-section">
            <button
              type="button"
              pButton
              pRipple
              icon="pi pi-plus"
              label="Ajouter une opération de maintenance"
              class="p-button-secondary p-button-outlined"
              (click)="addNew()"
            ></button>
          </div>
        </div>
      </form>

      <div *ngIf="!isFormValid" class="validation-warning">
        <div class="warning-content">
          <i class="pi pi-exclamation-triangle"></i>
          <span>{{ validationMessage }}</span>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="modal-footer">
      <button
        type="button"
        pButton
        pRipple
        label="Annuler"
        class="p-button-text"
        (click)="onCancel()"
      ></button>
      <button
        type="button"
        pButton
        pRipple
        label="Enregistrer"
        class="p-button-primary"
        (click)="onSubmit()"
        [disabled]="!isFormValid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
